import React, { useContext, useEffect, useState } from 'react';
import { VirusLinks } from '@Types/log';
import i18next from 'i18next';
import { LogApi } from '@Apis';

const Context = React.createContext({} as VirusLinks);

export const useVirusLinks = () => useContext(Context);

const VirusLinksProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [virusLinks, setVirusLinks] = useState<VirusLinks>({});

  useEffect(() => {
    let lang = i18next.language;
    if (lang === 'en' || lang === 'pt') {
      lang = 'us';
    } else if (lang === 'ja') {
      lang = 'jp';
    }

    LogApi.getVirusLink({ language: lang })
      .then((data) => setVirusLinks(data))
      .catch((e) => console.error(e));
  }, []);

  return <Context.Provider value={virusLinks}>{children}</Context.Provider>;
};

export default VirusLinksProvider;
